import { all, call, put, takeLatest } from 'redux-saga/effects';

import * as errorHandlerActions from '@/components/errorHandler/Actions';
import * as freePlayActions from '@/pages/freePlay/Actions';
import * as playlistActions from '@/playlist/Actions';
import { freePlayActionTypes } from '@/pages/freePlay/Constants';
import {
	getFreePlayCategoryApiPath,
	getFreePlayLevelApiPath,
	ROUTES_API,
} from '@/services/Constants';
import { processRequest } from '@/services/Api';
import { historyPush } from '@/services/History';

export default function* (): Generator {
	yield all([
		takeLatest(freePlayActionTypes.GET_CATEGORIES_REQUEST, handleGetCategoriesRequest),
		takeLatest(freePlayActionTypes.GET_CATEGORY_REQUEST, handleGetCategoryRequest),
		takeLatest(freePlayActionTypes.GET_LEVEL_REQUEST, handleGetLevelRequest),
	]);
}

export function* handleGetCategoriesRequest() {
	try {
		const { data } = yield call(processRequest, ROUTES_API.FREE_PLAY_CATEGORIES);

		yield put(freePlayActions.getCategoriesSuccess(data));
	} catch (e: any) {
		if (e.status === 403) {
			yield call(historyPush, '/');
			return;
		}
		yield put(freePlayActions.getCategoriesError(e.message));
		yield put(errorHandlerActions.handleError(e, 'page-blocking'));
	}
}

export function* handleGetCategoryRequest({ payload }: any) {
	try {
		const { categoryId } = payload || {};

		const { data } = yield call(processRequest, getFreePlayCategoryApiPath(categoryId));

		// data.free_play_topic_category.current_level.learning_path[0].title = 'Surfende sommen';
		// data.free_play_topic_category.current_level.learning_path[0].game_name = 'LaneChooserGame';
		yield put(playlistActions.setCurrentLevel(data.free_play_topic_category.current_level));
		yield put(freePlayActions.getCategorySuccess(data.free_play_topic_category));
	} catch (e: any) {
		yield put(freePlayActions.getCategoryError(e.message));
		yield put(errorHandlerActions.handleError(e, 'page-blocking'));
	}
}

export function* handleGetLevelRequest({ payload }: any) {
	try {
		const { levelId } = payload || {};

		const { data } = yield call(processRequest, getFreePlayLevelApiPath(levelId));

		yield put(freePlayActions.getLevelSuccess(levelId, data.learning_path));
	} catch (e: any) {
		yield put(freePlayActions.getLevelError(e.message));
		yield put(errorHandlerActions.handleError(e, 'page-blocking'));
	}
}
